import Vue from 'vue';
import { mapGetters } from 'vuex';
import TinyBar from 'src/components/project/analysis/results/widgets/TinyBar.vue';
import { BfButton } from 'components/Butterfly';
import Query from 'src/api/query';
import { calculateNPS, calculateNPSImpact, calculateOtherNPS } from 'src/utils/nps';
import FormatUtils from 'src/utils/formatters';
export default Vue.extend({
    components: { TinyBar, BfButton },
    props: {
        clickable: { type: Boolean, default: true },
        title: { type: String, default: 'Net Promoter Score (NPS)' },
        queries: { type: Array, required: false, default: () => [] },
        queryResultCounts: { type: Array, required: false, default: () => [] }
    },
    data() {
        return {
            waiting: 0,
            showingRawData: false,
            npsScores: [],
            impactScores: [],
            otherScores: [],
            colorQuery: ['rgb(17, 172, 223)', 'rgb(248, 149, 22)']
        };
    },
    computed: {
        ...mapGetters(['currentProject', 'hasNPS', 'currentModel', 'featureFlags', 'nps', 'savedQueries']),
        overallNpsScores() {
            return calculateNPS(this.nps.detractors, this.nps.passives, this.nps.promoters, true);
        },
        loading() {
            return this.waiting > 0 || this.npsScores.length === 0 || this.npsScores.length !== this.queries.length;
        },
    },
    watch: {
        queries() {
            this.$nextTick(() => { this.executeNpsQueries(); });
        }
    },
    mounted() {
        this.executeNpsQueries();
    },
    methods: {
        formatNPS: FormatUtils.formatNPS,
        async getQueryNPS(query) {
            try {
                this.waiting += 1;
                const response = await Query.getNpsData(this.$route.params.projectId, this.$route.params.analysisId, query, this.savedQueries);
                const queryNpsFreq = {
                    detractors: response.detractors.total_hits,
                    passives: response.passives.total_hits,
                    promoters: response.promoters.total_hits
                };
                return queryNpsFreq;
            }
            catch (e) {
                return null;
            }
            finally {
                this.waiting -= 1;
            }
        },
        async executeNpsQueries() {
            if (this.hasNPS === true) {
                this.queries.forEach(async (query, index) => {
                    this.waiting += 1;
                    try {
                        const freq = await this.getQueryNPS(query);
                        const scores = calculateNPS(freq.detractors, freq.passives, freq.promoters, true);
                        const impact = calculateNPSImpact({ ...this.nps, totalCount: this.currentModel.stats.n_documents }, { ...freq, totalCount: this.queryResultCounts[index] }, true);
                        const otherScores = calculateOtherNPS({ ...this.nps, totalCount: this.currentModel.stats.n_documents }, { ...freq, totalCount: this.queryResultCounts[index] }, true);
                        this.npsScores[index] = scores;
                        this.impactScores[index] = impact;
                        this.otherScores[index] = otherScores;
                    }
                    finally {
                        this.waiting -= 1;
                    }
                });
            }
        }
    }
});
